import { useState, useEffect } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAppServices } from "../../../hook/services";
import DataTable from "./components/DataTable";
import { Icon } from "@iconify/react";
import env from "../../../config";
import LoadingScreen from "../../../components/LoadingScreen";

const Accounts = () => {
  const navigate = useNavigate();
  const AppService = useAppServices();
  const [processing, setProcessing] = useState(true);
  const { companyId, appId } = useParams();
  const [accounts, setAccounts] = useState([]);

  const getData = async () => {
    const { response } = await AppService.app_installs.get({
      query: `companyId=${companyId}&appId=${appId}`,
    });
    if (response) {
      setAccounts(response.data);
      setProcessing(false);
    } else {
      setProcessing(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAppInstall = () => {
    const url = `https://app.gohighlevel.com/integration/${appId}`;
    window.open(url, "_blank");
  };
  const handleAppView = async (account_id) => {
    navigate(`./view/${account_id}`);
  };

  const columns = [
    {
      label: "Id",
      accessor: "id",
      sortable: true,
      renderCell: (row) => (
        <>
          <span className="text-dark fw-semibold">{row.locationId || "-"}</span>
        </>
      ),
    },
    {
      label: "Actions",
      accessor: "actions",
      renderCell: (row) => (
        <div className="d-flex gap-2 justify-content-center">
          <button
            className="btn btn-primary btn-sm rounded-3 shadow-sm d-flex align-items-center gap-2"
            onClick={() => handleAppView(row.locationId)}
            title="View"
          >
            <Icon icon="mdi:account-key-outline" width={18} />
            <span>View</span>
          </button>
        </div>
      ),
    },
  ];

  if (processing) {
    return <LoadingScreen loadingText={"Loading accounts..."} />;
  }

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#F5F6FA" }}>
      <div className="container-fluid p-4">
        {/* Header Card */}
        <div
          className="card border-0 shadow-sm mb-4"
          style={{ backgroundColor: "white" }}
        >
          <div className="card-body py-4">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold text-dark">Sub Accounts</h4>
                <p className="text-muted mb-0 small">
                  Manage your sub accounts
                </p>
              </div>
              <button
                className="btn btn-primary rounded-3 shadow-sm d-flex align-items-center gap-2"
                onClick={handleAppInstall}
                title="Install App"
              >
                <Icon icon="mdi:download" width={18} />
                <span>Install App</span>
              </button>
            </div>
          </div>
        </div>
        <DataTable columns={columns} data={accounts} entriesPerPage={10} />
      </div>
    </div>
  );
};

export default Accounts;
